import React, { Fragment } from "react";
import { makeStyles } from "@mui/styles";
import { TextField, Grid } from "@mui/material";
import InputMask from "react-input-mask";

const useStyles = makeStyles(theme => ({
  root: {
    margin: "-1rem 0 2rem 0",
    padding: "0 7rem",
    [theme.breakpoints.down("xs")]: {
      padding: "0"
    },
    [theme.breakpoints.down("md")]: {
      padding: "0"
    },
    marginTop: "auto"
  },
  textField: {
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  errorMessage: {
    color: "red",
    fontSize: "0.9rem",
    marginTop: "0.2rem"
  }
}));

export default function Contact({ formProps = {}, data = [] }) {
  const { register, errors = {} } = formProps;
  const classes = useStyles();
  const { name, email, mobilePhone } = data && data[0] ? data[0] : {};
  
  // Ensure default values are strings or empty strings
  const defaultName = name || "";
  const defaultEmail = email || "";
  const defaultMobilePhone = mobilePhone ? String(mobilePhone) : "";

  return (
    <Fragment>
      <div className={classes.root}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={1}
        >
          <Grid item md={12} xs={12}>
            <TextField
              id="name"
              label="Name"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              {...register("name", {
                required: "Please enter your name",
                pattern: {
                  value: /^[A-Za-z ]+$/,
                  message: "Please enter a valid name"
                }
              })}
              error={!!errors.name}
              defaultValue={defaultName}
            />
            {errors.name && (
              <p className={classes.errorMessage}>{errors.name.message}</p>
            )}
          </Grid>
          <Grid item md={12} xs={12}>

          <TextField
              id="email"
              label="Email"
              type="email"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              {...register("email", {
                required: "Please enter your email",
                pattern: {
                  value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                  message: "please enter a valid email"
                }
              })}
              error={!!errors.email}
              defaultValue={defaultEmail}
            />
            {errors.email && (
              <p className={classes.errorMessage}>{errors.email.message}</p>
            )} 
          </Grid>
          <Grid item md={12} xs={12}>
           
                <TextField
                  id="mobilePhone"
                  label="Mobile Phone"
                  type="tel"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  {...register("mobilePhone", {
                    required: "Please enter your mobile phone",
                  
                  })}
                  error={!!errors.mobilePhone}
                  defaultValue={defaultMobilePhone}
                />
           
            {errors.mobilePhone && (
              <p className={classes.errorMessage}>{errors.mobilePhone.message}</p>
            )}
          </Grid>
          <Grid item md={12} xs={12}>
           
                <TextField
                  id="specialRequirement"
                  label="Special Requirements"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  {...register("specialRequirement")}
                />
          </Grid>

          
        </Grid>
      </div>
    </Fragment>
  );
}
